<template>
    <kt-panel>
        <div class="accordion accordion-toggle-arrow" id="userFilter">
            <div class="card" style="overflow:inherit">
                <div class="card-header bg-transparent" id="headingOne">
                    <div class="card-title collapsed" data-toggle="collapse"
                         data-target="#filterForm"
                         aria-controls="filterForm">
                        {{ $t('label.search') }}
                    </div>
                </div>
                <div id="filterForm" class="collapse" aria-labelledby="filterForm" data-parent="#userFilter">
                    <div class="card-body">
                        <form @submit.prevent="action($event, query)">
                            <kt-form-section>
                                <kt-form-row>
                                  <kt-col xs="12" sm="6" md="3">
                                    <kt-form-group>
                                      <kt-form-label for="id">
                                        {{ $t('label.hashid') }}
                                      </kt-form-label>
                                      <kt-form-control
                                          ref="id"
                                          dir="rtl"
                                          name="id"
                                          id="id"
                                          v-model="query.id"
                                      />
                                    </kt-form-group>
                                  </kt-col>
                                    <kt-col xs="12" sm="6" md="3">
                                        <kt-form-group>
                                            <kt-form-label for="user_full_name">
                                                {{ $t('label.user_full_name') }}
                                            </kt-form-label>
                                            <kt-form-control
                                                ref="user_full_name"
                                                dir="rtl"
                                                name="user_full_name"
                                                id="user_full_name"
                                                v-model="query.user_full_name"
                                            />
                                        </kt-form-group>
                                    </kt-col>
                                    <kt-col xs="12" sm="6" md="3">
                                        <kt-form-group>
                                            <kt-form-label for="status">
                                                {{ $t('label.status') }}
                                            </kt-form-label>
                                            <kt-form-select
                                                size="3"
                                                id="status"
                                                class="form-control"
                                                name="status"
                                                v-model="query.status"
                                            >
                                                <option value=""></option>
                                                <option
                                                    v-bind:key="request_status"
                                                    v-for="request_status in openBankingTransactionStatus"
                                                    v-bind:value="request_status"
                                                    :selected="query.status === request_status"
                                                >
                                                    {{ openBankingTransactionStatusStr.get(request_status) }}
                                                </option>
                                            </kt-form-select>
                                        </kt-form-group>
                                    </kt-col>
                                    <kt-col   xs="12" sm="6" md="3">
                                        <kt-form-group>
                                            <kt-form-label for="provider">
                                                {{ `${$t('label.track_id')}  ${$t('label.acceptor')}` }}
                                            </kt-form-label>
                                            <input id="track_id" v-model="query.tracking_code" class="form-control">
                                        </kt-form-group>
                                    </kt-col>
                                    <kt-col xs="12" sm="6" md="3">
                                        <kt-form-group>
                                            <kt-form-label for="status">
                                                {{ $t('transaction_transfer.origin_account') }}
                                            </kt-form-label>
                                            <input id="track_id" v-model="query.origin_account" class="form-control">

                                        </kt-form-group>
                                    </kt-col>
                                    <kt-col xs="12" sm="6" md="3">
                                        <kt-form-group>
                                            <kt-form-label for="status">
                                                {{ $t('transaction_transfer.destination_account') }}
                                            </kt-form-label>
                                            <input id="track_id" v-model="query.destination_account" class="form-control">

                                        </kt-form-group>
                                    </kt-col>
                                    <kt-col xs="12" sm="6" md="3">
                                        <kt-form-group>
                                            <kt-form-label for="provider">
                                                {{ $t('label.deposit_type') }}
                                            </kt-form-label>
                                            <kt-form-select
                                                size="3"
                                                id="provider"
                                                class="form-control"
                                                name="provider"
                                                v-model="query.type"
                                            >
                                                <option value=""></option>
                                                <option
                                                    v-bind:key="index"
                                                    v-for="(item, index) in statementTransferType"
                                                    v-bind:value="item"
                                                >
                                                    {{ statementTransferTypeStr.get(item) }}
                                                </option>
                                            </kt-form-select>
                                        </kt-form-group>
                                    </kt-col>
                                    <kt-col xs="12" sm="3" md="3">
                                        <kt-form-group>
                                            <kt-form-label for="from_date">
                                                {{ $t('label.from_date') }}
                                            </kt-form-label>
                                            <button id="reset_from_date"
                                                    @click="clearFromDate"
                                                    class=" btn btn-label-danger trash-btn"
                                                    type="button"
                                            >
                                                <i class="la la-trash-o"></i>
                                            </button>
                                            <datePicker
                                                format="YYYY-MM-DD HH:mm:ss"
                                                display-format="dddd jDD jMMMM jYYYY HH:mm"
                                                type="datetime"
                                                input-class="form-control"
                                                id="from_date"
                                                name="from_date"
                                                v-model="query.from_date"/>
                                        </kt-form-group>
                                    </kt-col>
                                    <kt-col xs="12" sm="3" md="3">
                                        <kt-form-group>
                                            <kt-form-label for="to_date">
                                                {{ $t('label.to_date') }}
                                            </kt-form-label>
                                            <button id="reset_to_date"
                                                    @click="clearToDate"
                                                    class=" btn btn-label-danger trash-btn"
                                                    type="button"
                                            >
                                                <i class="la la-trash-o"></i>
                                            </button>
                                            <datePicker
                                                format="YYYY-MM-DD HH:mm:ss"
                                                display-format="dddd jDD jMMMM jYYYY HH:mm"
                                                type="datetime"
                                                input-class="form-control"
                                                id="to_date"
                                                name="to_date"
                                                v-model="query.to_date"
                                            />
                                        </kt-form-group>
                                    </kt-col>
                                </kt-form-row>
                            </kt-form-section>
                            <kt-form-section>
                                <div class="row">
                                    <div class="col-md-6">
                                        <input type="submit" class="btn btn-success btn-wide"
                                               :value="$t('label.filter')">
                                    </div>
                                </div>

                            </kt-form-section>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </kt-panel>
</template>

<script>
import {
    applicationServiceStatus, applicationServiceStatusStr, openBankingRequestsStatus,
    openBankingRequestsStatusStr, services, providerType, providerTypeStr,
    openBankingTransferDetectedType, openBankingTransferDetectedTypeStr
} from '@/constants/openBanking'
import {userTypes, userTypesStr} from '@/constants/userTypes'
import $ from "jquery";
import {i18n} from '@/plugins/i18n'
import {bankTransferTransaction, bankTransferTransactionStr} from "@/constants/bankTransferTransaction";
import {bankId, bankIdStr} from "@/constants/bankId";
import {
  bankTransferTransactionServiceType,
  bankTransferTransactionServiceTypeStr
} from "@/constants/bankTransferTransactionServiceType";
import {openBankingTransactionStatus, openBankingTransactionStatusStr} from "@/constants/openBankingTransactionStatus";
import {statementTransferType, statementTransferTypeStr} from "@/constants/statementTransferType";

export default {
    computed: {
      statementTransferType() {
        return statementTransferType
      },
      statementTransferTypeStr() {
        return statementTransferTypeStr
      },
      openBankingTransactionStatusStr() {
        return openBankingTransactionStatusStr
      },
      openBankingTransactionStatus() {
        return openBankingTransactionStatus
      },
      bankTransferTransactionServiceTypeStr() {
        return bankTransferTransactionServiceTypeStr
      },
      bankTransferTransactionServiceType() {
        return bankTransferTransactionServiceType
      },
        bankIdStr() {
            return bankIdStr
        },
        bankId() {
            return bankId
        },
        bankTransferTransactionStr() {
            return bankTransferTransactionStr
        },
        bankTransferTransaction() {
            return bankTransferTransaction
        }
    },
    props: {
        action: {
            default: function (e, query) {
            },
            required: true,
        }
    },
    mounted() {
        this.afterDispatch()
    },
    methods: {
        afterDispatch() {
            $('.kt-selectpicker').selectpicker({
                size: 4,
                liveSearch: true,
                noneResultsText: i18n.t('selectpicker.none_result'),
                selectAllText: i18n.t('selectpicker.select_all'),
                noneSelectedText: i18n.t('selectpicker.nothing_selected')
            })
        },
        clearFromDate() {
            if (this.query.from_date) {
                this.query.from_date = null
            }
        },
        clearToDate() {
            if (this.query.to_date) {
                this.query.to_date = null
            }
        },
    },
    data() {
        return {
            openBankingRequestsStatus,
            openBankingRequestsStatusStr,
            services,
            query: {
                status: null,
                detected_type: null,
            },
            applicationServiceStatus,
            applicationServiceStatusStr,
            userTypes,
            userTypesStr,
            providerType,
            providerTypeStr,
            openBankingTransferDetectedType,
            openBankingTransferDetectedTypeStr
        }
    }
}
</script>

<style scoped>

.export-excel {
    margin: 10px;
    border: 1px solid rgba(68, 0, 150, 1) !important;
    padding: 15px 60px;
    text-align: center;
    text-transform: uppercase;
    transition: 0.7s !important;
    font-weight: bold !important;
    background-size: 200% auto;
    color: rgba(68, 0, 150, 1) !important;
    border-radius: 5px !important;
    display: block;
}

.export-excel:hover {
    background-image: linear-gradient(to right, rgba(68, 0, 150, 1) 0%, rgba(255, 0, 155, 1) 51%, rgba(68, 0, 150, 1) 100%);
    background-position: right center;
    color: #fff !important;
    text-decoration: none !important;
    border: none !important;
    transition: 0.7s !important;
    font-weight: bold !important;
    box-shadow: 0 0 20px #eee;
}

</style>